import { UnderwritingStepStatus } from '@api';
import { CheckCircle, CircleOutlined, HideSource } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './StatusChecklistItem.module.scss';


interface StatusChecklistItemProps {
    className?: string;
    selected?: boolean;
    status?: UnderwritingStepStatus;
    done?: boolean;
    label: ReactNode;
}

export default function StatusChecklistItem({
    className, selected, status, label, done
}: StatusChecklistItemProps) {
    const icon = status === UnderwritingStepStatus.SUBMITTED || done ? (
        <CheckCircle
            fontSize="inherit"
            color="success"
        />
    ) : status === UnderwritingStepStatus.WAIVED
        ? (
            <Tooltip title="This step has been waived, you do not need to complete it to finish underwriting.">
                <HideSource fontSize="inherit" />
            </Tooltip>
        )
        : <CircleOutlined fontSize="inherit" />;

    return (
        <Typography
            className={clsx(styles.root, className, {
                [styles.selected]: selected
            })}
        >
            {icon}

            {label}
        </Typography>
    );
}
